import type { SlashMenuTooltip } from '@blocksuite/affine-widget-slash-menu';
import { html } from 'lit';
// prettier-ignore
const TextTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_868" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_868)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="15.6364">分布式系统中的数据关系</tspan><tspan x="8" y="27.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="43.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="55.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="71.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="83.6364">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="95.6364">电脑重新连接网络后，修改</tspan><tspan x="8" y="107.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="123.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="135.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const Heading1Tooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_873" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_873)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="28" font-weight="bold" letter-spacing="-0.24px"><tspan x="8" y="34.1818">一级标题</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="51.6364">分布式系统中的数据关系</tspan><tspan x="8" y="63.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="79.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="91.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="107.636">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="119.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="131.636">电脑重新连接网络后，修改</tspan><tspan x="8" y="143.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="159.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="171.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const Heading2Tooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_880" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_880)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="26" font-weight="600" letter-spacing="-0.24px"><tspan x="8" y="33.4545">二级标题</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="51.6364">分布式系统中的数据关系</tspan><tspan x="8" y="63.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="79.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="91.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="107.636">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="119.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="131.636">电脑重新连接网络后，修改</tspan><tspan x="8" y="143.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="159.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="171.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const Heading3Tooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_887" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_887)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="24" font-weight="600" letter-spacing="-0.24px"><tspan x="8" y="30.7273">三级标题</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="47.6364">分布式系统中的数据关系</tspan><tspan x="8" y="59.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="75.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="87.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="103.636">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="115.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="127.636">电脑重新连接网络后，修改</tspan><tspan x="8" y="139.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="155.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="167.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const Heading4Tooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_894" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_894)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="22" font-weight="600" letter-spacing="0.24px"><tspan x="8" y="29">四级标题</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="45.6364">分布式系统中的数据关系</tspan><tspan x="8" y="57.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="73.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="85.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="101.636">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="113.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="125.636">电脑重新连接网络后，修改</tspan><tspan x="8" y="137.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="153.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="165.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const Heading5Tooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_901" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_901)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="20" font-weight="600" letter-spacing="0.24px"><tspan x="8" y="27.2727">五级标题</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="43.6364">分布式系统中的数据关系</tspan><tspan x="8" y="55.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="71.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="83.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="99.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="111.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="123.636">电脑重新连接网络后，修改</tspan><tspan x="8" y="135.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="151.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="163.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const Heading6Tooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_908" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_908)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="18" font-weight="600" letter-spacing="0.24px"><tspan x="8" y="25.5455">六级标题</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="41.6364">分布式系统中的数据关系</tspan><tspan x="8" y="53.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="69.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="81.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="97.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="109.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="121.636">电脑重新连接网络后，修改</tspan><tspan x="8" y="133.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="149.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="161.636">修改，也可以保留当前文档。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const CodeBlockTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_915" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_915)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="var(--affine-font-code-family)" font-size="11" letter-spacing="0em"><tspan x="47.5742" y="17.46"> </tspan><tspan x="126.723" y="17.46">: </tspan><tspan x="166.297" y="17.46"> {&#10;</tspan><tspan x="8" y="32.46">    </tspan><tspan x="100.34" y="32.46"> helloTo </tspan><tspan x="166.297" y="32.46"> &#34;世界&#34;&#10;</tspan><tspan x="8" y="47.46">    </tspan><tspan x="54.1699" y="47.46"> body: </tspan><tspan x="126.723" y="47.46"> </tspan><tspan x="159.701" y="47.46"> {&#10;</tspan><tspan x="8" y="62.46">        </tspan><tspan x="87.1484" y="62.46">(</tspan><tspan x="219.062" y="62.46">)&#10;</tspan><tspan x="8" y="77.46">}&#10;</tspan><tspan x="8" y="92.46">}</tspan></text>
<text fill="#0782A0" xml:space="preserve" style="white-space: pre" font-family="var(--affine-font-code-family)" font-size="11" letter-spacing="0em"><tspan x="8" y="17.46">struct</tspan><tspan x="73.957" y="32.46"> var</tspan><tspan x="159.701" y="32.46">=</tspan><tspan x="34.3828" y="47.46">var</tspan><tspan x="100.34" y="47.46">some</tspan><tspan x="139.914" y="62.46">\(</tspan></text>
<text fill="#842ED3" xml:space="preserve" style="white-space: pre" font-family="var(--affine-font-code-family)" font-size="11" letter-spacing="0em"><tspan x="54.1699" y="17.46">ContentView</tspan></text>
<text fill="#C62222" xml:space="preserve" style="white-space: pre" font-family="var(--affine-font-code-family)" font-size="11" letter-spacing="0em"><tspan x="139.914" y="17.46">View</tspan><tspan x="34.3828" y="32.46">@State</tspan><tspan x="133.318" y="47.46">View</tspan></text>
<text fill="#2159D3" xml:space="preserve" style="white-space: pre" font-family="var(--affine-font-code-family)" font-size="11" letter-spacing="0em"><tspan x="60.7656" y="62.46">Text</tspan></text>
<text fill="#D34F0B" xml:space="preserve" style="white-space: pre" font-family="var(--affine-font-code-family)" font-size="11" letter-spacing="0em"><tspan x="93.7441" y="62.46">&#34;你好 </tspan><tspan x="153.105" y="62.46">helloTo)!&#34;</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const QuoteTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_920" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_920)">
<rect x="12" y="14" width="2" height="33" rx="1" fill="#C2C1C5"/>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="24" y="26.6364">分布式系统中的数据关系</tspan><tspan x="24" y="40.6364">可能具有多种复杂形式。&#10;…</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const DividerTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_928" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_928)">
<text fill="black" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="16.6364">分布式系统中的数据关系</tspan><tspan x="8" y="30.6364">可能具有多种复杂形式。&#10;</tspan><tspan x="8" y="54.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="68.6364">选择分享的数据，</tspan><tspan x="8" y="82.6364">或接收的数据都有不同看法。&#10;</tspan><tspan x="8" y="106.636">例如，用户可以在飞机上</tspan><tspan x="8" y="120.636">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="134.636">飞机抵达后，</tspan><tspan x="8" y="148.636">电脑重新连接网络，修改</tspan><tspan x="8" y="162.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="186.636">其他用户可以接收全部修改，</tspan><tspan x="8" y="200.636">也可以接收部分修改，</tspan><tspan x="8" y="214.636">或者保留当前文档。</tspan></text>
<line x1="8.25" y1="40.75" x2="169.75" y2="40.75" stroke="#E3E2E4" stroke-width="0.5" stroke-linecap="round"/>
</g>
</svg>
`;

// prettier-ignore
const BulletedListTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_934" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_934)">
<circle cx="14" cy="26" r="1.5" fill="#1C81D9"/>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="22" y="29.6364">这是项目列表的示例。</tspan></text>
<circle cx="14" cy="42" r="1.5" fill="#1C81D9"/>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="22" y="45.6364">你可以这样列出自己的计划。</tspan></text>
</g>
</svg>
`;

// prettier-ignore
const NumberedListTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_947" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_947)">
<g clip-path="url(#clip0_16460_947)">
<text fill="#1C81D9" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="10" y="29.6364">1.</tspan></text>
</g>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="24" y="29.6364">这是编号列表的示例。</tspan></text>
<g clip-path="url(#clip1_16460_947)">
<text fill="#1C81D9" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="10" y="45.6364">2.</tspan></text>
</g>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="24" y="45.6364">你可以这样列出自己的计划。</tspan></text>
</g>
<defs>
<clipPath id="clip0_16460_947">
<rect width="16" height="16" fill="white" transform="translate(10 18)"/>
</clipPath>
<clipPath id="clip1_16460_947">
<rect width="16" height="16" fill="white" transform="translate(10 34)"/>
</clipPath>
</defs>
</svg>
`;

// prettier-ignore
export const BoldTextTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_971" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_971)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="43.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="55.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="71.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="83.6364">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="95.6364">电脑重新连接网络后，修改</tspan><tspan x="8" y="107.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="123.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="135.636">修改，也可以保留当前文档。</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" font-weight="bold" letter-spacing="0px"><tspan x="8" y="15.6364">分布式系统中的数据关系</tspan><tspan x="8" y="27.6364">可能具有多种复杂形式。&#10;</tspan></text>
</g>
</svg>
`;

// prettier-ignore
export const ItalicTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_976" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_976)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="43.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="55.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="71.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="83.6364">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="95.6364">电脑重新连接网络后，修改</tspan><tspan x="8" y="107.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="123.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="135.636">修改，也可以保留当前文档。</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" font-style="italic" letter-spacing="0px"><tspan x="8" y="15.6364">分布式系统中的数据关系</tspan><tspan x="8" y="27.6364">可能具有多种复杂形式。&#10;</tspan></text>
</g>
</svg>
`;

// prettier-ignore
export const StrikethroughTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_986" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_986)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="43.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="55.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="71.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="83.6364">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="95.6364">电脑重新连接网络后，修改</tspan><tspan x="8" y="107.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="123.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="135.636">修改，也可以保留当前文档。</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px" text-decoration="line-through"><tspan x="8" y="15.6364">分布式系统中的数据关系</tspan><tspan x="8" y="27.6364">可能具有多种复杂形式。&#10;</tspan></text>
</g>
</svg>
`;

// prettier-ignore
export const UnderlineTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_981" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_981)">
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="43.6364">每位用户对自己持有的数据，</tspan><tspan x="8" y="55.6364">分享或接收的数据有不同看法。&#10;</tspan><tspan x="8" y="71.6364">例如，用户可以在乘坐飞机时</tspan><tspan x="8" y="83.6364">使用笔记本电脑编辑文档。</tspan><tspan x="8" y="95.6364">电脑重新连接网络后，修改</tspan><tspan x="8" y="107.636">将同步给其他用户。&#10;</tspan><tspan x="8" y="123.636">其他用户可以接收全部、部分</tspan><tspan x="8" y="135.636">修改，也可以保留当前文档。</tspan></text>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px" text-decoration="underline"><tspan x="8" y="15.6364">分布式系统中的数据关系</tspan><tspan x="8" y="27.6364">可能具有多种复杂形式。&#10;</tspan></text>
</g>
</svg>
`;

// prettier-ignore
export const TodoTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_5604_203551" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_5604_203551)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.6667 19C12.7462 19 12 19.7462 12 20.6667V27.3333C12 28.2538 12.7462 29 13.6667 29H20.3333C21.2538 29 22 28.2538 22 27.3333V20.6667C22 19.7462 21.2538 19 20.3333 19H13.6667ZM12.9091 20.6667C12.9091 20.2483 13.2483 19.9091 13.6667 19.9091H20.3333C20.7517 19.9091 21.0909 20.2483 21.0909 20.6667V27.3333C21.0909 27.7517 20.7517 28.0909 20.3333 28.0909H13.6667C13.2483 28.0909 12.9091 27.7517 12.9091 27.3333V20.6667Z" fill="#77757D"/>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="28" y="27.6364">这是待办列表的示例。</tspan></text>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 40.6667C12 39.7462 12.7462 39 13.6667 39H20.3333C21.2538 39 22 39.7462 22 40.6667V47.3333C22 48.2538 21.2538 49 20.3333 49H13.6667C12.7462 49 12 48.2538 12 47.3333V40.6667ZM19.7457 42.5032C19.9232 42.3257 19.9232 42.0379 19.7457 41.8604C19.5681 41.6829 19.2803 41.6829 19.1028 41.8604L16.0909 44.8723L15.2002 43.9816C15.0227 43.8041 14.7349 43.8041 14.5574 43.9816C14.3799 44.1591 14.3799 44.4469 14.5574 44.6244L15.7695 45.8366C15.947 46.0141 16.2348 46.0141 16.4123 45.8366L19.7457 42.5032Z" fill="#1E96EB"/>
<text fill="#8E8D91" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="28" y="47.6364">列出制作预览需要完成的任务。</tspan></text>
</g>
</svg>
`;

export const tooltips: Record<string, SlashMenuTooltip> = {
  Text: {
    figure: TextTooltip,
    caption: '文本',
  },

  'Heading 1': {
    figure: Heading1Tooltip,
    caption: '一级标题',
  },

  'Heading 2': {
    figure: Heading2Tooltip,
    caption: '二级标题',
  },

  'Heading 3': {
    figure: Heading3Tooltip,
    caption: '三级标题',
  },

  'Heading 4': {
    figure: Heading4Tooltip,
    caption: '四级标题',
  },

  'Heading 5': {
    figure: Heading5Tooltip,
    caption: '五级标题',
  },

  'Heading 6': {
    figure: Heading6Tooltip,
    caption: '六级标题',
  },

  'Code Block': {
    figure: CodeBlockTooltip,
    caption: '代码块',
  },

  Quote: {
    figure: QuoteTooltip,
    caption: '引用',
  },

  Divider: {
    figure: DividerTooltip,
    caption: '分隔线',
  },

  'Bulleted List': {
    figure: BulletedListTooltip,
    caption: '项目列表',
  },

  'Numbered List': {
    figure: NumberedListTooltip,
    caption: '编号列表',
  },

  Bold: {
    figure: BoldTextTooltip,
    caption: '加粗文字',
  },

  Italic: {
    figure: ItalicTooltip,
    caption: '斜体',
  },

  Underline: {
    figure: UnderlineTooltip,
    caption: '下划线',
  },

  Strikethrough: {
    figure: StrikethroughTooltip,
    caption: '删除线',
  },

  'To-do List': {
    figure: TodoTooltip,
    caption: '待办列表',
  },
};
